import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {GalleryHomepageComponent} from './gallery-homepage/gallery-homepage.component';
import {GalleryBannerHomepageComponent} from './gallery-banner-homepage/gallery-banner-homepage.component';
import {SwiperModule} from "ngx-swiper-wrapper";
import {TranslateModule} from '@ngx-translate/core';
import {DirectivesModule} from '../../providers/directives/directives.module';


@NgModule({
    declarations: [GalleryHomepageComponent, GalleryBannerHomepageComponent],
    imports: [
        CommonModule,
        SwiperModule,
        TranslateModule,
        DirectivesModule
    ],
    exports: [GalleryHomepageComponent, GalleryBannerHomepageComponent]
})
export class GalleriesModule {
}
